import * as R from "ramda";

const root = R.lensProp("platform-reporting");

const dashboards = R.compose(root, R.lensProp("dashboards"));

const selectedDashboardId = R.compose(root, R.lensProp("selectedDashboardId"));

const embed = R.compose(root, R.lensProp("embed"));

const error = R.compose(root, R.lensProp("error"));

const loadingDashboards = R.compose(root, R.lensProp("loadingDashboards"));

const loadingEmbed = R.compose(root, R.lensProp("loadingEmbed"));

export default Object.assign(root, {
  dashboards,
  selectedDashboardId,
  embed,
  error,
  loadingDashboards,
  loadingEmbed,
});
